import { Box, Flex, keyframes } from '@chakra-ui/react';
import { rem } from 'polished';

const load = keyframes`
  0% {
    transform: translateY(-200%);
    opacity: 0;
  }
  15%, 85% {
    transform: translateY(0);
    opacity: 1;
  }
  100% {
    transform: translateY(200%);
    opacity: 0;
  }
`;

export const LoadingDots = ({ color = 'gray.4', size = rem(4) }) => (
  <Flex gap="space.4">
    <Box animation={`${load} infinite 1.5s linear 0s`} boxSize={size} bg={color} rounded={rem(1)} />
    <Box
      animation={`${load} infinite 1.5s linear 0.1s`}
      boxSize={size}
      bg={color}
      rounded={rem(1)}
    />
    <Box
      animation={`${load} infinite 1.5s linear 0.2s`}
      boxSize={size}
      bg={color}
      rounded={rem(1)}
    />
  </Flex>
);
